import EcoSvg from "@icons/eco.svg?react";
import FeedsSvg from "@icons/feeds.svg?react";
import MarketPlaceSvg from "@icons/marketplace.svg?react";
import OilSvg from "@icons/oil.svg?react";
import PlanProtectionSvg from "@icons/plant-protection.svg?react";
import SeedsSvg from "@icons/seeds.svg?react";

import { CropCategory, CropUnit } from "@/generated/digitalnisklady.cz/graphql";

const Card = ({
  category,
  name,
  parameters,
  className,
  children,
}: React.PropsWithChildren<{
  category: CropCategory;
  name: string;
  unit: CropUnit;
  parameters: string[][];
  className?: string;
}>) => {
  return (
    <article
      className={`text-can-slate-blue-gray shadow-can-light-box flex-wrap flex gap-2 items-center rounded-2xl p-4 text-xs ${className}`}
    >
      <Icon category={category} />
      <Material>{name}</Material>

      <Parameters>
        {parameters.map((p, i) => (
          <span key={p[0]}>
            {p.join(": ")}
            {i === parameters.length - 1 ? "" : ", "}
          </span>
        ))}
      </Parameters>
      {children}
    </article>
  );
};

const Material = ({ children }: React.PropsWithChildren) => {
  return (
    <h3 className="text-can-midnight-steel font-bold text-base">{children}</h3>
  );
};

const Parameters = ({ children }: React.PropsWithChildren) => (
  <p className="text-can-slate-blue-gray w-full">{children}</p>
);

const Icon = ({ category }: { category: CropCategory }) => {
  switch (category) {
    case CropCategory.Eko:
      return <EcoSvg className="w-4 h-4" />;
    case CropCategory.Fuel:
      return <OilSvg className="w-4 h-4" />;
    case CropCategory.Feed:
      return <FeedsSvg className="w-4 h-4" />;
    case CropCategory.Fertilizer:
      return (
        <MarketPlaceSvg className="[&_path]:fill-can-midnight-steel  w-4 h-4" />
      );
    case CropCategory.PlantProtection:
      return <PlanProtectionSvg className="w-4 h-4" />;
    case CropCategory.Seed:
      return <SeedsSvg className="w-4 h-4" />;
    default:
      return null;
  }
};

export { Card };
